module.exports = __webpack_public_path__ + "static/gym-barmer-67b3a88be4afe1ddf99e02a46d623ae8.png";